/* Copied from: https://ui.shadcn.com/docs/components/label */
/* No styling has been applied to this component */

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva } from "class-variance-authority";

import { twJoin, twMerge } from "tailwind-merge";

const labelVariants = cva(
  "text-sm font-medium leading-none cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

const FormLabel = React.forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={twMerge(twJoin(labelVariants(), className))}
    {...props}
  />
));
FormLabel.displayName = LabelPrimitive.Root.displayName;

export { FormLabel };
